<template>
  <v-row justify="center" class="mx-xl-6 mx-lg-6 mx-md-6" no-gutters v-if="_claim">
    <v-col xl="8" lg="9" md="10" sm="12" cols="12">
      <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pb-xl-12 pb-lg-12 pb-md-8 pb-sm-4 pb-4" no-gutters>
        <v-col class="pr-xl-3 pr-lg-3 pr-md-3" cols="12">
          <v-card outlined>
            <v-toolbar flat dense color="#F9F9F9">
              <v-toolbar-title class="section-title px-2">
                <span v-if="_claim.id != null">Modificar reclamo</span>
                <span v-else>Crear reclamo</span>
              </v-toolbar-title>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="text-left py-0 px-0">
              <claim-form :claim="_claim" @save="claimSaved"></claim-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <div v-else>
    <form-loader></form-loader>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import ClaimForm from '@/components/Claim/ClaimForm'
import FormLoader from '@/loaders/FormLoader'

export default {
  name: 'CreateClaim',
  mixins: [navigationMixin],
  components: {
    ClaimForm,
    FormLoader
  },
  computed: {
    ...mapState('shared', ['error']),
    ...mapState('claim', ['_claim'])
  },
  methods: {
    ...mapActions('claim', ['getClaimByPurchase']),
    claimSaved () {
      if (this.error.status) {
        this.$emit('notificationPopup', { icon: 'error', color: 'error', message: this.error.message })
        return
      }

      this.goToRouteByName('Claims')
    }
  },
  mounted () {
    this.getClaimByPurchase(this.$route.params.purchase_id)
  }
}
</script>
